import { useEffect, useRef } from "react";

// Lightweight canvas ember/sparkular effect (rising glowing red particles)
export default function Embers({ density = 60 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w, h, particles, raf;

    const resize = () => {
      w = canvas.width = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
    };

    const make = () => ({
      x: Math.random() * w,
      y: h + Math.random() * h,
      r: Math.random() * 2.2 + 0.4,
      vy: Math.random() * 0.7 + 0.2,
      vx: (Math.random() - 0.5) * 0.3,
      life: Math.random(),
      hue: 355 + Math.random() * 12,
    });

    const init = () => {
      resize();
      particles = Array.from({ length: density }, make);
    };

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of particles) {
        p.y -= p.vy;
        p.x += p.vx;
        p.life -= 0.0025;
        const alpha = Math.max(0, Math.min(0.8, p.life));
        ctx.beginPath();
        ctx.fillStyle = `hsla(${p.hue}, 85%, 60%, ${alpha})`;
        ctx.shadowBlur = 12;
        ctx.shadowColor = `hsla(${p.hue}, 90%, 55%, ${alpha})`;
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
        if (p.y < -10 || p.life <= 0) Object.assign(p, make(), { y: h + 10 });
      }
      raf = requestAnimationFrame(draw);
    };

    init();
    if (!prefersReduced) draw();
    window.addEventListener("resize", init);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", init);
    };
  }, [density]);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 h-full w-full"
      aria-hidden="true"
      data-testid="embers-canvas"
    />
  );
}
